import Label from "components/general/Label"
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStop } from "@fortawesome/free-solid-svg-icons";
import {
  isLiveStatus,
} from "helpers/status";

import { useViewport } from 'components/general/useViewPort';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const blueCard = <FontAwesomeIcon className='text-primary' icon={faStop} />
const redCard = <FontAwesomeIcon className='text-danger' icon={faStop} />

/*
Main component
Renders result page for KIK Light Contact and Full Contact
*/
const KikContact = ({ data }) => {
  const { mirs_discipline,mirs_rsc } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();

  const resultStatus = data?.results?.status?.code;
  let lightContact = mirs_rsc.includes('LC')

  let current = ''
  if (isLiveStatus(resultStatus)) {
    current = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'PERIOD')?.ei_value;
  }

  let periods = data?.results?.periods
  let home = data?.results?.home
  let away = data?.results?.away
  let r1 = periods?.find(i => i?.p_code === 'R1')
  let r2 = periods?.find(i => i?.p_code === 'R2')
  let r3 = periods?.find(i => i?.p_code === 'R3')
  let round1 = r1?.extendedPeriods
  let round2 = r2?.extendedPeriods
  let round3 = r3?.extendedPeriods
  let totalRed = home?.extendedResults
  let totalBlue = away?.extendedResults

  return (
    <div className="bkg-individual-main">
      <Table>
        <thead>
          <tr>
            <th className="round" rowSpan="2"></th>
                {current === 'R1'
                  ? <th className="votes text-center score-current" colSpan={2}><Label data="HeaderRound1" sport={mirs_discipline}/></th>
                  : <th className="votes text-center" colSpan={2}><Label data="HeaderRound1" /></th>
                }
                {current === 'R2'
                  ? <th className="votes text-center score-current" colSpan={2}><Label data="HeaderRound2" sport={mirs_discipline}/></th>
                  : <th className="votes text-center" colSpan={2}><Label data="HeaderRound2" /></th>
                }
                {current === 'R3'
                  ? <th className="votes text-center score-current" colSpan={2}><Label data="HeaderRound3" sport={mirs_discipline}/></th>
                  : <th className="votes text-center" colSpan={2}><Label data="HeaderRound3" /></th>
                }
                <th className="votes text-center" colSpan={2}><Label data="HeaderTotal" sport={mirs_discipline}/></th>
          </tr>
          <tr>
            <th className='vote text-center'>{redCard} {(breakPoint !== "sm" && breakPoint !== "xs") ? <Label data="LabelBkgRed" sport={mirs_discipline} /> : ''}</th>
            <th className='vote text-center'>{blueCard} {(breakPoint !== "sm" && breakPoint !== "xs") ? <Label data="LabelBkgBlue" sport={mirs_discipline} /> : ''}</th>
            <th className='vote text-center'>{redCard} {(breakPoint !== "sm" && breakPoint !== "xs") ? <Label data="LabelBkgRed" sport={mirs_discipline} /> : ''}</th>
            <th className='vote text-center'>{blueCard} {(breakPoint !== "sm" && breakPoint !== "xs") ? <Label data="LabelBkgBlue" sport={mirs_discipline} /> : ''}</th>
            <th className='vote text-center'>{redCard} {(breakPoint !== "sm" && breakPoint !== "xs") ? <Label data="LabelBkgRed" sport={mirs_discipline} /> : ''}</th>
            <th className='vote text-center'>{blueCard} {(breakPoint !== "sm" && breakPoint !== "xs") ? <Label data="LabelBkgBlue" sport={mirs_discipline} /> : ''}</th>
            <th className='vote text-center'>{redCard} {(breakPoint !== "sm" && breakPoint !== "xs") ? <Label data="LabelBkgRed" sport={mirs_discipline} /> : ''}</th>
            <th className='vote text-center'>{blueCard} {(breakPoint !== "sm" && breakPoint !== "xs") ? <Label data="LabelBkgBlue" sport={mirs_discipline} /> : ''}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="votes text-start fw-bold">
              <Label data="HeaderJudge1"/>
            </td>
            <td className="text-center">{round1 ? getRoundsData(periods, 'R1', 0) : ''}</td>
            <td className="text-center">{round1 ? getRoundsData(periods, 'R1', 1) : ''}</td>
            <td className="text-center">{round2 ? getRoundsData(periods, 'R2', 0) : ''}</td>
            <td className="text-center">{round2 ? getRoundsData(periods, 'R2', 1) : ''}</td>
            <td className="text-center">{round3 ? getRoundsData(periods, 'R3', 0) : ''}</td>
            <td className="text-center">{round3 ? getRoundsData(periods, 'R3', 1) : ''}</td>
            <td className="text-center">{totalRed ? getTotals(totalRed, 'J1', 1) : ''}</td>
            <td className="text-center">{totalBlue ? getTotals(totalBlue, 'J1', 2) : ''}</td>
          </tr>
          <tr>
            <td className="votes text-start fw-bold">
              <Label data="HeaderJudge2"/>
            </td>
            <td className="text-center">{round1 ? getRoundsData(periods, 'R1', 2) : ''}</td>
            <td className="text-center">{round1 ? getRoundsData(periods, 'R1', 3) : ''}</td>
            <td className="text-center">{round2 ? getRoundsData(periods, 'R2', 2) : ''}</td>
            <td className="text-center">{round2 ? getRoundsData(periods, 'R2', 3) : ''}</td>
            <td className="text-center">{round3 ? getRoundsData(periods, 'R3', 2) : ''}</td>
            <td className="text-center">{round3 ? getRoundsData(periods, 'R3', 3) : ''}</td>
            <td className="text-center">{totalRed ? getTotals(totalRed, 'J2') : ''}</td>
            <td className="text-center">{totalBlue ? getTotals(totalBlue, 'J2') : ''}</td>
          </tr>
          <tr>
            <td className="votes text-start fw-bold">
              <Label data="HeaderJudge3"/>
            </td>
            <td className="text-center">{round1 ? getRoundsData(periods, 'R1', 4) : ''}</td>
            <td className="text-center">{round1 ? getRoundsData(periods, 'R1', 5) : ''}</td>
            <td className="text-center">{round2 ? getRoundsData(periods, 'R2', 4) : ''}</td>
            <td className="text-center">{round2 ? getRoundsData(periods, 'R2', 5) : ''}</td>
            <td className="text-center">{round3 ? getRoundsData(periods, 'R3', 4) : ''}</td>
            <td className="text-center">{round3 ? getRoundsData(periods, 'R3', 5) : ''}</td>
            <td className="text-center">{totalRed ? getTotals(totalRed, 'J3') : ''}</td>
            <td className="text-center">{totalBlue ? getTotals(totalBlue, 'J3') : ''}</td>
          </tr>
          {lightContact
            ?
            <>
              <tr>
                <td className="votes text-start fw-bold">
                  <Label data="HeaderExits"/>
                </td>
                <td className="text-center">{totalRed ? getExits(totalRed, 'R1') : ''}</td>
                <td className="text-center">{totalBlue ? getExits(totalBlue, 'R1') : ''}</td>
                <td className="text-center">{totalRed ? getExits(totalRed, 'R2') : ''}</td>
                <td className="text-center">{totalBlue ? getExits(totalBlue, 'R2') : ''}</td>
                <td className="text-center">{totalRed ? getExits(totalRed, 'R3') : ''}</td>
                <td className="text-center">{totalBlue ? getExits(totalBlue, 'R3') : ''}</td>
                <td className="text-center">{totalRed ? getExits(totalRed, 'TOT') : ''}</td>
                <td className="text-center">{totalBlue ? getExits(totalBlue, 'TOT') : ''}</td>
              </tr>
            </>
            :
            <>
              <tr>
                <td className="votes text-start fw-bold">
                  <Label data="HeaderKickCount"/>
                </td>
                <td className="text-center">{totalRed ? getKickCount(totalRed, 'R1') : ''}</td>
                <td className="text-center">{totalBlue ? getKickCount(totalBlue, 'R1') : ''}</td>
                <td className="text-center">{totalRed ? getKickCount(totalRed, 'R2') : ''}</td>
                <td className="text-center">{totalBlue ? getKickCount(totalBlue, 'R2') : ''}</td>
                <td className="text-center">{totalRed ? getKickCount(totalRed, 'R3') : ''}</td>
                <td className="text-center">{totalBlue ? getKickCount(totalBlue, 'R3') : ''}</td>
                <td className="text-center">{totalRed ? getKickCount(totalRed, 'TOT') : ''}</td>
                <td className="text-center">{totalBlue ? getKickCount(totalBlue, 'TOT') : ''}</td>
              </tr>
            </>
          }
          <tr>
            <td className="votes text-start fw-bold">
              <Label data="HeaderWarnings"/>
            </td>
            <td className="text-center">{totalRed ? getWarnings(totalRed, 'R1') : ''}</td>
            <td className="text-center">{totalBlue ? getWarnings(totalBlue, 'R1') : ''}</td>
            <td className="text-center">{totalRed ? getWarnings(totalRed, 'R2') : ''}</td>
            <td className="text-center">{totalBlue ? getWarnings(totalBlue, 'R2') : ''}</td>
            <td className="text-center">{totalRed ? getWarnings(totalRed, 'R3') : ''}</td>
            <td className="text-center">{totalBlue ? getWarnings(totalBlue, 'R3') : ''}</td>
            <td className="text-center">{totalRed ? getWarnings(totalRed, 'TOT') : ''}</td>
            <td className="text-center">{totalBlue ? getWarnings(totalBlue, 'TOT') : ''}</td>
          </tr>
          <tr>
            <td className="votes text-start fw-bold">
              <Label data="HeaderMinusPts"/>
            </td>
            <td className="text-center">{totalRed ? getMinusPts(totalRed, 'R1') : ''}</td>
            <td className="text-center">{totalBlue ? getMinusPts(totalBlue, 'R1') : ''}</td>
            <td className="text-center">{totalRed ? getMinusPts(totalRed, 'R2') : ''}</td>
            <td className="text-center">{totalBlue ? getMinusPts(totalBlue, 'R2') : ''}</td>
            <td className="text-center">{totalRed ? getMinusPts(totalRed, 'R3') : ''}</td>
            <td className="text-center">{totalBlue ? getMinusPts(totalBlue, 'R3') : ''}</td>
            <td className="text-center">{totalRed ? getMinusPts(totalRed, 'TOT') : ''}</td>
            <td className="text-center">{totalBlue ? getMinusPts(totalBlue, 'TOT') : ''}</td>
          </tr>
          <tr>
            <td className="votes text-start fw-bold">
              <Label data="HeaderKnockdown" sport={mirs_discipline} />
            </td>
            <td className="text-center">{totalRed ? getKD(totalRed, 'R1') : ''}</td>
            <td className="text-center">{totalBlue ? getKD(totalBlue, 'R1') : ''}</td>
            <td className="text-center">{totalRed ? getKD(totalRed, 'R2') : ''}</td>
            <td className="text-center">{totalBlue ? getKD(totalBlue, 'R2') : ''}</td>
            <td className="text-center">{totalRed ? getKD(totalRed, 'R3') : ''}</td>
            <td className="text-center">{totalBlue ? getKD(totalBlue, 'R3') : ''}</td>
            <td className="text-center">{totalRed ? getKD(totalRed, 'TOT') : ''}</td>
            <td className="text-center">{totalBlue ? getKD(totalBlue, 'TOT') : ''}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}

const getRoundsData = (periods, round, n) => {
  return periods?.find(i => i?.p_code === round)?.extendedPeriods[n]?.ep_value
}

const getExits = (homeAway, round) => {
  return homeAway?.find(ext => ext.er_code === 'EXITS' && ext.er_pos === round)?.er_value
}

const getKickCount = (homeAway, round) => {
  return homeAway?.find(ext => ext.er_code === 'KICK_COUNT' && ext.er_pos === round)?.er_value
}

const getWarnings = (homeAway, round) => {
  return homeAway?.find(ext => ext.er_code === 'WARNING' && ext.er_pos === round)?.er_value
}

const getMinusPts = (homeAway, round) => {
  return homeAway?.find(ext => ext.er_code === 'MINUS_PTS' && ext.er_pos === round)?.er_value
}

const getKD = (homeAway, round) => {
  return homeAway?.find(ext => ext.er_code === 'KD' && ext.er_pos === round)?.er_value
}

const getTotals = (homeAway, round) => {
  return homeAway?.find(ext => ext.er_code === 'POINTS' && ext.er_pos === round)?.er_value
}

export default KikContact;